import {
  Label,
  LabelColors,
  LabelVisibility,
} from '@aibees/elephant/types/label';
import { useEffect, useState } from 'react';
import { labelColors } from './config';

export const useLabelFormState = ({
  isEdit,
  item,
}: {
  isEdit?: boolean;
  item?: Label;
}) => {
  const [labelName, setLabelName] = useState<string>(item?.name || '');
  const [checked, setChecked] = useState(false);
  const [colors, setColors] = useState<LabelColors[]>(labelColors);
  const [isNameChanged, setIsNameChanged] = useState(false);
  const [isVisibilityChanged, setIsVisibilityChanged] = useState(false);
  const [isColorChanged, setIsColorChanged] = useState(false);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setLabelName(value);

    if (isEdit && item) {
      setIsNameChanged(value !== item.name);
    }
  };

  const handleVisibilityChange = (value: boolean) => {
    setChecked(value);
    if (isEdit && item) {
      const wasPrivate = item.visibility === LabelVisibility.PRIVATE;
      setIsVisibilityChanged(wasPrivate !== value);
    }
  };

  const handleColorChange = (hexCode: string) => {
    setColors((prevColors) =>
      prevColors.map((prevColor) =>
        prevColor.hexCode === hexCode
          ? { ...prevColor, selected: true }
          : { ...prevColor, selected: false }
      )
    );

    if (isEdit && item) {
      setIsColorChanged(item.color !== hexCode);
    }
  };

  useEffect(() => {
    if (isEdit && item) {
      setChecked(item.visibility === LabelVisibility.PRIVATE);
      setLabelName(item.name || '');
      handleColorChange(item.color);
      setIsNameChanged(false);
      setIsVisibilityChanged(false);
      setIsColorChanged(false);
    } else {
      handleColorChange(labelColors[0].hexCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, item]);

  const isFormChanged = isNameChanged || isVisibilityChanged || isColorChanged;

  return {
    labelName,
    setLabelName,
    checked,
    setChecked,
    colors,
    onChange,
    handleColorChange,
    handleVisibilityChange,
    isFormChanged,
  };
};
